import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableCell,
  TableRow,
} from '@material-ui/core';

import NumberInput from '../FormInput/NumberInput';

class EcommDataNumberRow extends Component {
  render() {
    const {
      canEdit,
      getTabIndex,
      handleChange,
      locationData,
      max,
      min,
      rowTitle,
      valueKey,
    } = this.props;
    return (
      <TableRow>
        <TableCell key="additionalItems" className="ecommTableLabel">
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {rowTitle}
          </Box>
        </TableCell>
        {Object.keys(locationData).map((element, index) => {
          return (
            <TableCell key={element} className="studioDataRight">
              <NumberInput
                tabIndex={getTabIndex(index)}
                className="studioDataRight"
                max={max}
                min={min}
                value={locationData[element][valueKey] || 0}
                name={valueKey}
                disabled={!canEdit}
                onChange={event => handleChange(event, element)}
              />
            </TableCell>
          );
        })}
      </TableRow>
    )
  }
}

EcommDataNumberRow.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  getTabIndex: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  locationData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  rowTitle: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
}

EcommDataNumberRow.defaultProps = {
  min: 0,
  max: null,
};

export default EcommDataNumberRow;
